export default "__VITE_ASSET__DMv9CZlG__"